export enum PERMISSION_TYPE {
  GET_USER = 'GetUser',
  CREATE_USER = 'CreateUser',
  VIEW_USERS = 'ViewUsers',
  DELETE_USER = 'DeleteUser',
  UPDATE_USER = 'UpdateUser',
  CREATE_ADMIN = 'CreateAdmin',
  CREATE_UPLOADER_USER = 'CreateUploaderUser',
  DELETE_UPLOADER_USER = 'DeleteUploaderUser',
  UPDATE_UPLOADER_USER = 'UpdateUploaderUser',
  NO_ORGANIZATION_RELATED = 'NoOrganizationRelated',
  GET_DEVICE = 'GetDevice',
  CREATE_DEVICE = 'CreateDevice',
  UPDATE_DEVICE = 'UpdateDevice',
  DELETE_DEVICE = 'DeleteDevice',
  VIEW_DEVICES = 'ViewDevices',
  GET_ORGANIZATION = 'GetOrganization',
  CREATE_ORGANIZATION = 'CreateOrganization',
  UPDATE_ORGANIZATION = 'UpdateOrganization',
  DELETE_ORGANIZATION = 'DeleteOrganization',
  VIEW_ORGANIZATIONS = 'ViewOrganizations',
  CHANGE_ORGANIZATION_SETTINGS = 'ChangeOrganizationSettings',
  CHANGE_CUSTOM_RESOLUTION = 'ChangeCustomResolution',
  CREATE_ENTITY_IN_OTHER_ORGANIZATION = 'CreateEntityInOtherOrganization',
  GET_EVENT = 'GetEvent',
  CREATE_EVENT = 'CreateEvent',
  UPDATE_EVENT = 'UpdateEvent',
  DELETE_EVENT = 'DeleteEvent',
  VIEW_EVENTS = 'ViewEvents',
  GLOBAL_ACCESS = 'GlobalLevelAccess', //TODO: Check with team
  EVENT_ACCESS = 'EventLevelAccess', //TODO: Check with team
  ORG_ACCESS = 'OrgLevelAccess', //TODO: Check with team
  CREATE_COVER_PHOTO = 'CreateCoverPhoto',
  UPDATE_COVER_PHOTO = 'UpdateCoverPhoto',
  GET_COVER_PHOTO = 'GetCoverPhoto',
  DELETE_COVER_PHOTO = 'DeleteCoverPhoto',
  VIEW_COVER_PHOTOS = 'ViewCoverPhotos',
  GET_STREAM_LINK = 'GetStreamLink',
  GET_PUBLIC_STREAM_LINK = 'GetPublicStreamLink',
  CREATE_STREAM_INVITATION = 'CreateStreamInvitation',
  VIEW_STREAM_INVITATIONS = 'ViewStreamInvitations',
  DELETE_STREAM_INVITATION = 'DeleteStreamInvitation',
  CREATE_STREAM_EVENT = 'CreateStreamEvent',
  UPDATE_STREAM_EVENT = 'UpdateStreamEvent',
  CONTROL_STREAM = 'ControlStream',
  CHANGE_STREAM_STATUS = 'ChangeStreamEventStatus',
  CONTROL_ASSETS = 'ControlAssets',
  VIEW_TEXT = 'ViewText',
  VIEW_THEMES = 'ViewThemes',
  GET_VIDEO_THEME = 'GetVideoTheme',
  CREATE_VIDEO_THEME = 'CreateVideoTheme',
  UPDATE_VIDEO_THEME = 'UpdateVideoTheme',
  DELETE_VIDEO_THEME = 'DeleteVideoTheme',
  VIEW_STOCK_CLIPS = 'ViewStockClips',
  GET_STOCK_CLIP = 'GetStockClip',
  CREATE_STOCK_CLIP = 'CreateStockClip',
  UPDATE_STOCK_CLIP = 'UpdateStockClip',
  DELETE_STOCK_CLIP = 'DeleteStockClip',
  VIEW_PAYMENT_PLANS = 'ViewPaymentPlans',
  GET_PAYMENT_PLAN = 'GetPaymentPlan',
  CREATE_PAYMENT_PLAN = 'CreatePaymentPlan',
  UPDATE_PAYMENT_PLAN = 'UpdatePaymentPlan',
  DELETE_PAYMENT_PLAN = 'DeletePaymentPlan',
  VIEW_PLAYLISTS = 'ViewPlaylist',
  GET_PLAYLISTS = 'GetPlaylist',
  CREATE_PLAYLISTS = 'CreatePlaylist',
  UPDATE_PLAYLISTS = 'UpdatePlaylist',
  DELETE_PLAYLISTS = 'DeletePlaylist',
  VIEW_PLAYER_RELEASES = 'ViewPlayerReleases',
  GET_PLAYER_RELEASE = 'GetPlayerReleases',
  CREATE_PLAYER_RELEASE = 'CreatePlayerRelease',
  UPDATE_PLAYER_RELEASE = 'UpdatePlayerRelease',
  DELETE_PLAYER_RELEASE = 'DeletePlayerRelease',
  VIEW_EVENT_TEMPLATES = 'GetAllCeremonyTemplates',
  GET_EVENT_TEMPLATE = 'GetCeremonyTemplate',
  CREATE_EVENT_TEMPLATE = 'CreateCeremonyTemplate',
  UPDATE_EVENT_TEMPLATE = 'UpdateCeremonyTemplate',
  DELETE_EVENT_TEMPLATE = 'DeleteCeremonyTemplate',
  CREATE_TEXT_OVERLAY = 'CreateTextOverlay',
  UPDATE_TEXT_OVERLAY = 'UpdateTextOverlay',
  DELETE_TEXT_OVERLAY = 'DeleteTextOverlay',
  VIEW_TEXT_OVERLAY = 'ViewTextOverlay',
  VIEW_DASHBOARD = 'ViewDashboard',
  CREATE_PUBLIC_ASSET = 'CreatePublicAsset',
  CREATE_TRIBUTE_VIDEO = 'CreateTributeVideoEntity',
  VIEW_EVENT_LOGS = 'ViewEventLogs',
  RESET_MFA_FOR_USER = 'ResetMfaForUser',
  SHOW_HIDDEN_LOGIN_PROVIDERS = 'ShowHiddenLoginProviders',
  SHOW_INTERNAL_PROVIDERS = 'ShowInternalProviders',
  USE_SUPPORT_CHAT = 'UseSupportChat',
  CHANGE_ORGANIZATION_BRANDING = 'ChangeOrganizationBranding'
}
